import React from 'react';

const CostMetricsCard = ({ totalSqft, totalCost, header }) => {
  return (
    <div className="container mt-3">
      <div className="row justify-content-center">
        <div className="col-12 col-sm-10 col-md-8">
          <div className="card shadow-sm">
            <div className="card-body p-3">
              <div className="row">
                {/* Square Footage Metric */}
                <div className="col-6 border-end text-center">
                  <div className="mb-2">
                    <i className="fas fa-ruler-combined fs-4 text-primary"></i>
                  </div>
                  <h6 className="text-muted mb-1">Total Sqft</h6>
                  <h5 className="fw-bold mb-0">
                    {totalSqft}
                    <small className="text-muted fs-6 ms-1">sqft</small>
                  </h5>
                </div>

                {/* Cost Metric */}
                <div className="col-6 text-center">
                  <div className="mb-2">
                    <i className="fas fa-dollar-sign fs-4 text-success"></i>
                  </div>
                  <h6 className="text-muted mb-1">{header}</h6>
                  <h5 className="fw-bold mb-0">
                    ${totalCost}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostMetricsCard;
